import InputAdornment from "@mui/material/InputAdornment"
import TextField from "@mui/material/TextField"
import { useEffect, useState } from "react"

/**
 * The text a number box shows: money gets thousands separators while typing.
 * Whole-number fields drop anything after a decimal point.
 */
export function formatNumberInput(raw, { money = false, whole = false } = {}) {
  if (raw == null || raw === "") {
    return ""
  }
  let text = String(raw).replace(/[^\d.-]/g, "")
  const negative = text.startsWith("-")
  text = text.replace(/-/g, "")
  let [integer, ...decimals] = text.split(".")
  let decimal = decimals.join("")
  if (whole) {
    decimal = ""
    decimals = []
  }
  if (money) {
    integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }
  const hasPoint = decimals.length > 0
  return `${negative ? "-" : ""}${integer}${hasPoint ? `.${decimal}` : ""}`
}

export function parseNumberInput(text, { whole = false } = {}) {
  const cleaned = String(text ?? "").replace(/[^\d.-]/g, "")
  if (cleaned === "" || cleaned === "-" || cleaned === ".") {
    return null
  }
  const n = whole ? parseInt(cleaned, 10) : parseFloat(cleaned)
  return Number.isFinite(n) ? n : null
}

export default function NumberValueInput({
  label,
  value,
  onChange,
  money = false,
  whole = false,
  helperText,
}) {
  const [text, setText] = useState(() =>
    formatNumberInput(value, { money, whole })
  )

  // Follow outside changes (operator switch, reset) without fighting typing.
  useEffect(() => {
    if (parseNumberInput(text, { whole }) !== (value ?? null)) {
      setText(formatNumberInput(value, { money, whole }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  return (
    <TextField
      size="small"
      label={label}
      value={text}
      helperText={helperText}
      sx={{ width: "100%" }}
      inputProps={{ inputMode: whole ? "numeric" : "decimal" }}
      InputProps={
        money
          ? {
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
            }
          : undefined
      }
      onChange={(event) => {
        const next = formatNumberInput(event.target.value, { money, whole })
        setText(next)
        onChange(parseNumberInput(next, { whole }))
      }}
    />
  )
}
